import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { has, isEmpty } from '../../../helpers/javascriptHelpers'
import {
    getStatusAction,
    sendRegistrationAction,
    getShopInfoAction,
    getCountriesAction,
    getCountrySubdivisionsAction,
    getTaxingCategoryListAction,
    getShopTypeListAction,
    validateNewShopNameAction,
} from '../../../actions/appActions'
import { strings } from '../../../localization/strings'
import Loader from '../../loaders'
import { Button, Grid, Typography } from '@material-ui/core/index'
import { mailRegExp, phoneRegExp, passwordRegExp } from '../../../utils/regex'
import ReCAPTCHA from 'react-google-recaptcha'
import {
    removeReCaptchaToken,
    setReCaptchaToken,
} from '../../../helpers/dbHelpers'
import routes from '../../router/routes'
import * as db from '../../../helpers/dbHelpers'
import { getObjectValue, platforms, statusTypes } from '../../../server/shared'
import { parseUrl } from 'query-string'
import { getErrorType, isRequestUnathorized } from '../../../utils/exceptions'

import { appEnabled } from '../../../server/common'
import WarehouseContactForm from './warehouseContactForm'
import WarehouseAddressForm from './warehouseAddressForm'
import PickupScheduleForm from './pickupScheduleForm'
import RegistrationForm from './registrationForm'
import BillingInformationForm from './billingInformationForm'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import logotipoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'

export const platformsQueryString = {
    billowShop: 5,
}

const initialState = {
    reCaptchaToken: false,
    loader: false,
    showPasswordError: false,
    showBillingAddress: false,
    formData: {
        name: '',
        mail: '',
        phoneNumber: '',
        password: '',
        passwordConfirm: '',
        token: '',
        shopTypeId: null,
        shopName: '',
        shopNameIsValid: true,
        platformId: null,

        pickupSchedule: {
            startTime: moment('09:00', 'HH:mm'),
            endTime: moment('19:00', 'HH:mm'),
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: false,
            sunday: false,
        },
    },
    formDataError: {},
    dialogWarehouseAddress: false,
    dialogBillingAddress: false,
}

const style = {
    header: { textAlign: 'center' },
    form: {
        padding: '20px 10px',
        flexDirection: 'column',
        maxWidth: 500,
        margin: 'auto',
        width: '100%',
        display: 'flex',
    },
    field: { marginTop: 20 },
    button: { marginBottom: 10 },
    addressInfoWrapper: { display: 'flex', flexDirection: 'column' },
    addressInfoTitle: { margin: '20px auto 10px auto' },
    addressInfoContent: { display: 'flex', flexDirection: 'row' },
    addressInfoLabel: { opacity: 0.5, fontSize: '80%', height: '2em' },
    addressInfoData: { marginLeft: 20 },
    addressInfoError: { color: 'red', fontSize: '80%', margin: 'auto' },
}

class Component extends React.Component {
    state = {
        loader: true,
        ...initialState,
    }

    loadTaxingCategoryList = () => {
        getTaxingCategoryListAction()
            .then((x) => this.setState({ taxingCategoryList: x || [] }))
            .catch((x) => window.showDialog(x))
    }

    loadShopTypeList = () => {
        getShopTypeListAction()
            .then((x) => this.setState({ shopTypeList: x || [] }))
            .catch((x) => window.showDialog(x))
    }

    loadCountryList = () => {
        getCountriesAction()
            .then((x) => {
                if (x.length) {
                    this.setState({ countryList: x })
                    this.loadProvinceList(x[0].id)
                } else {
                    window.showDialog()
                }
            })
            .catch((x) => window.showDialog(x))
    }

    loadProvinceList = (countryId) => {
        getCountrySubdivisionsAction(countryId)
            .then((x) => {
                if (x.length) this.setState({ provinceList: x })
                else window.showDialog()
            })
            .catch((x) => window.showDialog(x))
    }

    validateFormData = () => {
        const platformId = db.getPlaftormId()
        const formData = this.state.formData

        var errors = {}
        var hasErrors = false

        if (!formData.name) errors.name = true
        if (!formData.mail || !mailRegExp.test(formData.mail))
            errors.mail = true
        if (!formData.shopTypeId) errors.shopTypeId = true
        if (!formData.phoneNumber || !phoneRegExp.test(formData.phoneNumber))
            errors.phoneNumber = true

        if (!formData.token) {
            if (!formData.shopName || !formData.shopNameIsValid)
                errors.shopName = true
        }

        if (platformId !== platforms.shopify) {
            if (!formData.password || !passwordRegExp.test(formData.password)) {
                errors.password = true
                this.setState({ showPasswordError: true })
            } else {
                this.setState({ showPasswordError: false })
            }
            if (formData.password !== formData.passwordConfirm) {
                errors.passwordConfirm = true
            }
        }
        if (Object.values(errors).some((x) => x === true)) hasErrors = true

        const warehouseContact = formData.warehouseContact || {}
        let warehouseContactEmptyFields = {}
        warehouseContactEmptyFields.name = isEmpty(warehouseContact.name)
        warehouseContactEmptyFields.mail = isEmpty(warehouseContact.mail)
        warehouseContactEmptyFields.phoneNumber = isEmpty(
            warehouseContact.phoneNumber
        )

        errors.warehouseContact = {
            name: false,
            mail: false,
            phoneNumber: false,
        }
        if (
            Object.values(warehouseContactEmptyFields).some((x) => x === false)
        ) {
            errors.warehouseContact = { ...warehouseContactEmptyFields }
            if (
                !warehouseContactEmptyFields.mail &&
                !mailRegExp.test(warehouseContact.mail)
            ) {
                errors.warehouseContact.mail = true
            }
            if (
                !warehouseContactEmptyFields.phoneNumber &&
                !phoneRegExp.test(warehouseContact.phoneNumber)
            ) {
                errors.warehouseContact.phoneNumber = true
            }
        }
        if (Object.values(errors.warehouseContact).some((x) => x === true))
            hasErrors = true

        const pickupSchedule = formData.pickupSchedule || {}
        errors.pickupSchedule = {}
        errors.pickupSchedule.startTime = isEmpty(pickupSchedule.startTime)
        errors.pickupSchedule.endTime = isEmpty(pickupSchedule.endTime)
        errors.pickupSchedule.days = isEmpty(
            Object.values(pickupSchedule).filter((x) => x === true)
        )
        if (Object.values(errors.pickupSchedule).some((x) => x === true))
            hasErrors = true

        const billingInformation = formData.billingInformation || {}
        errors.billingInformation = {}
        errors.billingInformation.cuit = isEmpty(billingInformation.cuit)
        if (Object.values(errors.billingInformation).some((x) => x === true))
            hasErrors = true

        const warehouseAddress = formData.warehouseAddress || {}
        errors.warehouseAddress = {}
        errors.warehouseAddress.country = !warehouseAddress.country
            ? true
            : isEmpty(warehouseAddress.country.name)
        errors.warehouseAddress.province = !warehouseAddress.province
            ? true
            : isEmpty(warehouseAddress.province.name)
        errors.warehouseAddress.streetAddress = isEmpty(
            warehouseAddress.streetAddress
        )
        errors.warehouseAddress.streetNumber = isEmpty(
            warehouseAddress.streetNumber
        )
        errors.warehouseAddress.city = isEmpty(warehouseAddress.city)
        errors.warehouseAddress.postalCode = isEmpty(
            warehouseAddress.postalCode
        )
        if (Object.values(errors.warehouseAddress).some((x) => x === true))
            hasErrors = true

        if (this.state.showBillingAddress) {
            const billingAddress = formData.billingAddress || {}
            errors.billingAddress = {}
            errors.billingAddress.country = !billingAddress.country
                ? true
                : isEmpty(billingAddress.country.name)
            errors.billingAddress.province = !billingAddress.province
                ? true
                : isEmpty(billingAddress.province.name)
            errors.billingAddress.streetAddress = isEmpty(
                billingAddress.streetAddress
            )
            errors.billingAddress.streetNumber = isEmpty(
                billingAddress.streetNumber
            )
            errors.billingAddress.city = isEmpty(billingAddress.city)
            errors.billingAddress.postalCode = isEmpty(
                billingAddress.postalCode
            )
            if (Object.values(errors.billingAddress).some((x) => x === true))
                hasErrors = true
        }

        if (hasErrors) {
            this.setState({ formDataError: errors })
            return false
        } else {
            return true
        }
    }

    sendRegistration = () => {
        if (!this.validateFormData()) return
        this.setState({ loader: true })
        const formData = this.state.formData

        let data = {
            token: formData.token,
            username: formData.mail,
            password: formData.password,
            name: formData.name,
            phoneNumber: formData.phoneNumber,
            shopTypeId: formData.shopTypeId,
            shopName: formData.shopName,
            platformId:
                formData.platformId && db.getPlaftormId() === 0
                    ? formData.platformId
                    : db.getPlaftormId(),
        }

        formData.billingInformation = formData.billingInformation || {}
        data.billingInformation = {
            cuit: formData.billingInformation.cuit,
            isValidated: formData.billingInformation.isValidated,
            businessName: !formData.billingInformation.isValidated
                ? null
                : formData.billingInformation.businessName,
            taxingCategoryId: !formData.billingInformation.isValidated
                ? null
                : formData.billingInformation.taxingCategoryId,
            contactMail: formData.billingInformation.contactMailBilling,
        }

        if (this.state.showBillingAddress) {
            formData.billingAddress = formData.billingAddress || {}
            data.billingAddress = {
                countryId: formData.billingAddress.country.id,
                countrySubdivisionId: formData.billingAddress.province.id,
                streetAddress: formData.billingAddress.streetAddress,
                streetNumber: formData.billingAddress.streetNumber,
                floor: formData.billingAddress.floor,
                apartment: formData.billingAddress.apartment,
                city: formData.billingAddress.city,
                postalCode: formData.billingAddress.postalCode,
            }
        }

        formData.warehouseAddress = formData.warehouseAddress || {}
        data.warehouseAddress = {
            countryId: formData.warehouseAddress.country.id,
            countrySubdivisionId: formData.warehouseAddress.province.id,
            streetAddress: formData.warehouseAddress.streetAddress,
            streetNumber: formData.warehouseAddress.streetNumber,
            floor: formData.warehouseAddress.floor,
            apartment: formData.warehouseAddress.apartment,
            city: formData.warehouseAddress.city,
            postalCode: formData.warehouseAddress.postalCode,
        }
        this.loadWarehouseContact(data, formData)

        formData.pickupSchedule = formData.pickupSchedule || {}
        data.pickupSchedule = {
            startTime: moment(formData.pickupSchedule.startTime).format(
                'HH:mm:ss'
            ),
            endTime: moment(formData.pickupSchedule.endTime).format('HH:mm:ss'),
            monday: formData.pickupSchedule.monday,
            tuesday: formData.pickupSchedule.tuesday,
            wednesday: formData.pickupSchedule.wednesday,
            thursday: formData.pickupSchedule.thursday,
            friday: formData.pickupSchedule.friday,
            saturday: formData.pickupSchedule.saturday,
            sunday: formData.pickupSchedule.sunday,
        }

        this.props
            .sendRegistrationAction(data)
            .then(() => {
                let message = strings.registrationFormSuccessContinueWithLogin

                if (db.getPlaftormId() === platforms.shopify)
                    message = strings.registrationFormSuccess

                window.showDialog(
                    {
                        title: strings.registrationFormSuccessTitle,
                        message: message,
                    },
                    () => {
                        if (db.getPlaftormId() === platforms.shopify)
                            this.props.history.replace(routes.orders.path)
                        else this.props.history.replace(routes.logIn.path)
                    }
                )
            })
            .catch((error) => {
                this.setState({
                    formData: {
                        ...this.state.formData,
                        password: '',
                        passwordConfirm: '',
                    },
                })
                let errorType = getErrorType(error)
                if (errorType === 'TokenNotFoundException') {
                    window.showDialog(error)
                } else {
                    window.showDialog(error, this.getStatus)
                }
            })
            .finally(() => {
                removeReCaptchaToken()
                this.setState({ loader: false, reCaptchaToken: false })
            })
    }

    loadWarehouseContact(data, formData) {
        data.warehouseContact = {}
        if (has(formData, 'warehouseContact.name') === false) {
            data.warehouseContact.name = formData.name
        } else {
            data.warehouseContact.name = formData.warehouseContact.name
        }

        if (has(formData, 'warehouseContact.mail') === false) {
            data.warehouseContact.mail = formData.mail
        } else {
            data.warehouseContact.mail = formData.warehouseContact.mail
        }

        if (has(formData, 'warehouseContact.phoneNumber') === false) {
            data.warehouseContact.phoneNumber = formData.phoneNumber
        } else {
            data.warehouseContact.phoneNumber =
                formData.warehouseContact.phoneNumber
        }
    }

    processRedirect = (response) => {
        const url = parseUrl(response.additionalData)
        if (url.url.includes('registrationForm') && url.query) {
            const token = !url.query.token ? null : url.query.token

            if (token) {
                this.setState({
                    formData: { ...this.state.formData, token: token },
                })
            } else {
                window.location = response.additionalData
            }
        } else {
            window.location = response.additionalData
        }
    }

    getStatus = () => {
        this.setState({ loader: true })
        this.props
            .getStatusAction()
            .then((response) => {
                if (appEnabled(response)) {
                    this.props.history.push(routes.orders.path)
                }
                if (response.status === statusTypes.Redirected) {
                    this.processRedirect(response)
                }
                if (response.status === statusTypes.Error) {
                    window.showDialog({ message: response.additionalData })
                }
            })
            .catch((error) => {
                if (isRequestUnathorized(error)) {
                    window.showDialog({
                        message: strings.exceptions.ApplicationException,
                    })
                } else {
                    window.showDialog(error, this.getStatus)
                }
            })
            .finally(() => {
                this.setState({ loader: false })
            })
    }

    loadShopInfo = (token) => {
        this.setState({ loader: true })
        this.props
            .getShopInfoAction(token)
            .then((response) => {
                if (response != null) {
                    this.setState((prevState) => ({
                        formData: {
                            // object that we want to update
                            ...prevState.formData, // keep all other key-value pairs
                            userName: response.userName,
                            name: response.name,
                            mail: response.mail,
                            shopTypeId: response.shopTypeId,
                            phoneNumber:
                                response.phone != null
                                    ? response.phone.length >= 10
                                        ? response.phone.slice(-10)
                                        : response.phone
                                    : null,
                            warehouseAddress: {
                                ...prevState.formData.warehouseAddress,
                                country: !response.address.countryId
                                    ? null
                                    : {
                                          id: response.address.countryId,
                                          name: response.address.countryName,
                                      },
                                province: !response.address.countrySubdivisionId
                                    ? null
                                    : {
                                          id: response.address
                                              .countrySubdivisionId,
                                          name: response.address
                                              .countrySubdivisionName,
                                      },
                                city: response.address.city,
                                streetAddress: response.address.streetAddress,
                                streetNumber: response.address.streetNumber,
                                floor: response.address.floor,
                                apartment: response.address.apartment,
                                postalCode: response.address.postalCode,
                            },
                        },
                    }))
                }
            })
            .catch((error) => {
                let errorType = getErrorType(error)
                if (errorType === 'TokenNotFoundException') {
                    window.showDialog(error)
                }
            })
            .finally(() => {
                this.setState({ loader: false })
            })
    }

    toggleShowBillingAddress = () => {
        const showBillingAddress = !this.state.showBillingAddress
        const billingAddress = initialState.formData.billingAddress

        this.setState({
            showBillingAddress: showBillingAddress,
            formData: {
                ...this.state.formData,
                billingAddress: billingAddress,
            },
        })
    }

    componentDidMount() {
        this.loadCountryList()
        this.loadTaxingCategoryList()
        this.loadShopTypeList()
        removeReCaptchaToken()

        var searchParams = new URLSearchParams(this.props.location.search)
        var formData = {
            ...this.state.formData,
            mail: searchParams.get('mail') || '',
            shopName: searchParams.get('shop') || '',
            platformId: getObjectValue(
                platformsQueryString,
                searchParams.get('platform')
            ),
            token: searchParams.get('token'),
        }

        this.setState({ formData: formData })
        if (formData.token != null) this.loadShopInfo(formData.token)
    }

    componentWillUnmount() {
        removeReCaptchaToken()
    }

    render() {
        const {
            loader,
            formData,
            formDataError,
            countryList,
            provinceList,
            taxingCategoryList,
            shopTypeList,
        } = this.state

        if (
            !countryList ||
            !provinceList ||
            !taxingCategoryList ||
            !shopTypeList
        )
            return <Loader />

        if (loader) return <Loader />

        //Hotfix:
        let formStyle = { ...style.form }
        if (window.innerWidth < 500) {
            formStyle.maxWidth = window.innerWidth - 20
        }
        const platformId = db.getPlaftormId()
        return (
            <div style={formStyle}>
                <img src={logotipoPudo} style={{width:'200px', margin:'30px auto'}} onClick={() => this.props.history.push('/')} />
                <Grid item style={style.header} xs={12}>
                    <Typography variant={'h6'}>
                        {strings.registrationHeader}
                    </Typography>
                </Grid>

                <RegistrationForm
                    style={style}
                    platformId={platformId}
                    onChange={(x) =>
                        this.setState({ formData: { ...formData, ...x } })
                    }
                    initialValue={formData || {}}
                    errors={formDataError || {}}
                    shopTypeList={shopTypeList}
                    validateNewShopName={validateNewShopNameAction}
                />

                <BillingInformationForm
                    onChange={(x) =>
                        this.setState({
                            formData: { ...formData, billingInformation: x },
                            formDataError: {
                                ...formDataError,
                                billingInformation: null,
                            },
                        })
                    }
                    initialValue={formData.billingInformation || {}}
                    taxingCategoryList={taxingCategoryList}
                    errors={formDataError.billingInformation || {}}
                    canOpen={!this.state.anyFormOpen}
                    toggleOpen={(x) => this.setState({ anyFormOpen: x })}
                    showBillingAddress={this.state.showBillingAddress}
                    toggleShowBillingAddress={this.toggleShowBillingAddress}
                    userMail={formData.mail}
                />

                <WarehouseAddressForm
                    onChange={(x) =>
                        this.setState({
                            formData: { ...formData, warehouseAddress: x },
                            formDataError: {
                                ...formDataError,
                                warehouseAddress: null,
                            },
                        })
                    }
                    title={strings.registrationWarehouseAddress}
                    afterTitleComponent={
                        <div style={{ fontSize: '80%', margin: 'auto' }}>
                            <FormControlLabel
                                style={{ marginTop: 'auto' }}
                                control={
                                    <Checkbox
                                        checked={this.state.showBillingAddress}
                                        onChange={this.toggleShowBillingAddress}
                                    />
                                }
                                label={strings.registrationShowBillingAddress}
                            />
                        </div>
                    }
                    initialValue={formData.warehouseAddress || {}}
                    countryList={countryList}
                    provinceList={provinceList}
                    errors={formDataError.warehouseAddress || {}}
                    canOpen={!this.state.anyFormOpen}
                    toggleOpen={(x) => this.setState({ anyFormOpen: x })}
                />

                <div
                    style={{
                        display: !this.state.showBillingAddress
                            ? 'none'
                            : 'block',
                    }}
                >
                    <WarehouseAddressForm
                        title={strings.registrationBillingAddress}
                        onChange={(x) =>
                            this.setState({
                                formData: { ...formData, billingAddress: x },
                            })
                        }
                        initialValue={formData.billingAddress || {}}
                        countryList={countryList}
                        provinceList={provinceList}
                        errors={formDataError.billingAddress || {}}
                        canOpen={!this.state.anyFormOpen}
                        toggleOpen={(x) => this.setState({ anyFormOpen: x })}
                    />
                </div>

                <WarehouseContactForm
                    onChange={(x) =>
                        this.setState({
                            formData: { ...formData, warehouseContact: x },
                            formDataError: {
                                ...formDataError,
                                warehouseContact: null,
                            },
                        })
                    }
                    initialValue={formData.warehouseContact || {}}
                    errors={formDataError.warehouseContact || {}}
                    canOpen={!this.state.anyFormOpen}
                    toggleOpen={(x) => this.setState({ anyFormOpen: x })}
                />

                <PickupScheduleForm
                    onChange={(x) =>
                        this.setState({
                            formData: { ...formData, pickupSchedule: x },
                            formDataError: {
                                ...formDataError,
                                pickupSchedule: null,
                            },
                        })
                    }
                    initialValue={formData.pickupSchedule || {}}
                    errors={formDataError.pickupSchedule || {}}
                    canOpen={!this.state.anyFormOpen}
                    toggleOpen={(x) => this.setState({ anyFormOpen: x })}
                />

                <ReCAPTCHA
                    style={{ width: 300, margin: '40px auto' }}
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={(token) => {
                        setReCaptchaToken(token)
                        this.setState({ reCaptchaToken: true })
                    }}
                />

                <Button
                    style={style.button}
                    label={strings.contactSearchButton}
                    variant="contained"
                    color="primary"
                    onClick={this.sendRegistration}
                    disabled={!this.state.reCaptchaToken}
                    fullWidth
                >
                    {strings.contactSubmitButton}
                </Button>
            </div>
        )
    }
}

const mapDispatchToProps = {
    sendRegistrationAction,
    getStatusAction,
    getShopInfoAction,
}
const mapStateToProps = () => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
